/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import classNames from 'classnames';
import Wishlist from 'src/components/Wishlist';
import HotelRatingSquare from 'src/components/HotelRatingSquare';
import { CashBack } from '@lt/components';
import HotelCardGallery from '../HotelCardGallery';
import type { HotelImage } from '../../types';
import AlreadySeenLabel from './components/AlreadySeenLabel';
import HotelCardStars from '../HotelCardStars';
import HotelCardTitle from '../HotelCardTitle';
import HotelCardLocation from '../HotelCardLocation';

import styles from './hotelCardGalleryOverlay.module.css';

type HotelCardGalleryOverlayProps = {
  images: HotelImage[];
  price: number;
  isMobile: boolean;
  hotelPageVisited: boolean;
  bonusCount: number;
  stars: number;
  hotelName: string;
  hotelLocation: string;
  rating: number;
  reviewsCount?: number;
  id: number;
  isMapCard?: boolean;
  hotelPageHref: string;
  openInCurrentTab: boolean;
  cashbackTooltipText?: string;
  cashbackLabel?: string;
  cashbackIconWebp?: string;
  cashbackIconPng?: string;
  labelColor: string;
  textColor: string;
};

const HotelCardGalleryOverlay: React.FC<HotelCardGalleryOverlayProps> = (
  props,
) => {
  const {
    images,
    price,
    isMobile,
    hotelPageVisited,
    bonusCount,
    stars,
    hotelName,
    hotelLocation,
    rating,
    reviewsCount,
    isMapCard = false,
    hotelPageHref,
    openInCurrentTab,
    id,
    cashbackLabel,
    cashbackIconWebp,
    cashbackIconPng,
    cashbackTooltipText,
    labelColor,
    textColor,
  } = props;

  return (
    <div
      className={classNames(styles.overlay, {
        [styles.overlayMobile]: isMobile,
        [styles.overlayMapCardMobile]: isMobile && isMapCard,
      })}
    >
      {isMobile ? (
        <a
          className={styles.linkToHotel}
          href={hotelPageHref}
          target={openInCurrentTab ? '_self' : '_blank'}
        >
          <HotelCardGallery
            images={images}
            isMobile={isMobile}
            isMapCard={isMapCard}
          />
        </a>
      ) : (
        <HotelCardGallery
          images={images}
          isMobile={isMobile}
          isMapCard={isMapCard}
        />
      )}

      <div className={styles.labels}>
        {bonusCount ? (
          <CashBack
            count={`+${bonusCount}`}
            labelColor={labelColor}
            textColor={textColor}
            isMobile={isMobile}
            label={cashbackLabel}
            cashbackIconWebp={cashbackIconWebp}
            cashbackIconPng={cashbackIconPng}
            cashbackTooltipText={cashbackTooltipText}
          />
        ) : null}
        {hotelPageVisited && <AlreadySeenLabel />}
      </div>

      <div className={styles.topRightOverlayPart}>
        {isMobile ? (
          <Wishlist
            price={price}
            className={styles.styledWishListButton}
            type="hotel"
            wishlistIdentifier={id}
            isWhiteHeart={isMobile}
            isHotelCardFromMap={isMapCard}
          />
        ) : (
          <HotelRatingSquare reviewsCount={reviewsCount} value={rating} />
        )}
      </div>

      {isMobile && (
        <div className={styles.bottomOverlayPart}>
          <div className={styles.titleWidth}>
            <HotelCardStars value={stars} />
            <HotelCardTitle
              hotelPageHref={hotelPageHref}
              isMobile={isMobile}
              openInCurrentTab={openInCurrentTab}
            >
              {hotelName}
            </HotelCardTitle>
            <HotelCardLocation isMobile={isMobile}>
              {hotelLocation}
            </HotelCardLocation>
          </div>
          <HotelRatingSquare reviewsCount={reviewsCount} value={rating} />
        </div>
      )}
    </div>
  );
};

export default HotelCardGalleryOverlay;
